// Keeps [data-no-clipboard] inputs out of the clipboard both ways. Cut and
// drag carry the value out just as copy does, and drop puts one in like paste.
const BLOCKED_EVENTS = ['copy', 'cut', 'paste', 'dragstart', 'drop'] as const;

// Delegated from the root so inputs swapped in by htmx are covered without
// rebinding.
export function blockClipboard(root: Document = document): void {
    for (const type of BLOCKED_EVENTS) {
        root.addEventListener(type, event => {
            if (
                event.target instanceof Element &&
                event.target.closest('[data-no-clipboard]')
            ) {
                event.preventDefault();
            }
        });
    }
}

blockClipboard();
